import React, { useState } from "react";
import "./CreateUserAccessSection.scss";
import { useFormik } from "formik";
import * as Yup from "yup";

const CreateUserAccessSection = () => {
  const userFormik = useFormik({
    initialValues: {
      user: "",
      role: "",
    },
    validationSchema: Yup.object({
      user: Yup.string().required("User is required"),
      role: Yup.string().required("Role is required"),
    }),
    onSubmit: (values) => {
      console.log("Form data", values);
    },
  });

  return (
    <>
      <div className="create-user-access-section">
        <h5 className="form-title">User Access Management</h5>
        <form className="user-info" onSubmit={userFormik.handleSubmit}>
          <div className="user-inputs">
            <div className="row">
              <div className="col-md-6 p-2">
                <div className="floating-label">
                  <select
                    name="user"
                    value={userFormik.values.user}
                    onChange={userFormik.handleChange}
                    onBlur={userFormik.handleBlur}
                  >
                    <option value="">Select User</option>
                    <option value="user1">User 1</option>
                    <option value="user2">User 2</option>
                    <option value="user3">User 3</option>
                  </select>
                  <label className="floating-label-text">User</label>
                  {userFormik.touched.user && userFormik.errors.user && (
                    <div className="error">{userFormik.errors.user}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6 p-2">
                <div className="floating-label">
                  <select
                    name="role"
                    value={userFormik.values.role}
                    onChange={userFormik.handleChange}
                    onBlur={userFormik.handleBlur}
                  >
                    <option value="">Choose Role</option>
                    <option value="eSim">eSim</option>
                    <option value="Flights">Flights</option>
                    <option value="Hotel">Hotel</option>
                    <option value="Tours">Tours</option>
                  </select>
                  <label className="floating-label-text">Role</label>
                  {userFormik.touched.role && userFormik.errors.role && (
                    <div className="error">{userFormik.errors.role}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
        <h5 className="form-title mt-4">Permissions</h5>
        <div className="table-responsive">
          <table className="table table-borderless">
            <thead>
              <tr>
                <th>Module</th>
                <th>View</th>
                <th>Create</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Booking</td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Pricing Markup</td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Deals Management</td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>User Access</td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input type="checkbox" name="Draft" />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CreateUserAccessSection;
